import imgAnalisa from '../../assets/image/gagal_analisa.png';
import imgProduk from '../../assets/image/img-produk-2.png';
import iconWarning from '../../assets/icon/icon-warning.svg';
import iconChevronUp from '../../assets/icon/icon_chevron_up.svg';
import { useState } from 'react';

const HasilAnalisaNopathologies = (props) => {
  const { analisa } = props;

  return (
    <div className="flex-grow flex flex-col justify-center items-center w-full my-5 md:my-14 md:px-10">
      <div className="">
        <img
          src={analisa.image_url}
          className="w-full max-w-[350px] object-contain rounded-xl"
          alt="hasil analisa"
        />
      </div>
      <div className=" flex flex-none md:max-w-[450px] text-textGray mt-10">
        <p className="text-center">
          Hasil pemeriksaan mengindikasikan kulit sehat. Tetap jaga kesehatan
          kulit dengan baik agar terhindar dari penyakit kulit
        </p>
      </div>
    </div>
  );
};

export default HasilAnalisaNopathologies;
